import { HeadCell } from 'components/ui/EnhancedTable';
import useAxios from 'library/axios'; 
import { useState } from 'react';
import { IPayrollProcessing,  IPayrollProcessingSearch } from "../models/PayrollProcessing";
import { useTranslation  } from 'react-i18next';
import { ITextFilterElement } from 'components/ui/BasicTextFilterForm';
import { useNavigate } from 'react-router-dom';

import { addMonths, addDays } from 'date-fns';


const _ = () => {

    const axios = useAxios();     

    const createPayrollProcessing = async (payrollProcessing: IPayrollProcessing)  =>       
        await (await axios.post('/api/finance/payrollProcessing/create', payrollProcessing)).data;       
        
    const updatePayrollProcessing = async (payrollProcessing: IPayrollProcessing)  =>       
        await (await axios.post('/api/finance/payrollProcessing/update', payrollProcessing)).data; 
    
    const getPayrollProcessing = async (id  : number )  => {
      const {data} = (await axios.get(`/api/finance/payrollProcessing/get-payrollProcessing/${id}`));
      return await data;
    }

    const getPayrollProcessings = async (criteria: IPayrollProcessingSearch) : Promise<IPayrollProcessing[]> => {
    const {dateFrom, dateTo, type} = criteria;

    const sDateFrom = encodeURIComponent(dateFrom.toISOString().split('T')[0]);
    const sDateTo = encodeURIComponent(dateTo.toISOString().split('T')[0]);

    const {data} = (await axios.get(`/api/finance/payrollProcessing/get-payrollProcessings?sDateFrom=${sDateFrom}&sDateTo=${sDateTo}&type=${type}`));
      return await data;
    }

          
    return {    
      createPayrollProcessing,
      updatePayrollProcessing,

      getPayrollProcessing,
      getPayrollProcessings  
    } 
}

export default _;


export const useBasicFilterPayrollProcessing = ( onRowDoubleClick: (event: React.MouseEvent<unknown>, row: IPayrollProcessing) => void  ) => {

  const { getPayrollProcessings } = _();

  const { t, i18n } = useTranslation();   
  const navigate = useNavigate();

  

  const [headPayrollProcessingCells, setHeadPayrollProcessingCells]  = useState<HeadCell<IPayrollProcessing>[]>([
    {id:'startDate', label : t('Start date'),  display: true, type: 'date', },
    {id:'endDate', label : t('End date'),  display: true, type: 'date', },

  ]); 

  const [filterElements, ] = useState([       
        {name: 'dateFrom', text: t('Start date'), dataType: 'date' ,  value: '', dateValue: addMonths(new Date(), -1)},
        {name: 'dateTo', text: t('End date'), dataType: 'date'  , value: '', dateValue: new Date()},
            
            
      ]);

  const [filteredPayrollProcessings, ] = useState<IPayrollProcessing[]>([]); 

  const onFilterButtonClick = async (filterElements: ITextFilterElement[]): Promise<IPayrollProcessing[]> => {
            
    const dateFrom = filterElements.find( elt => elt.name === 'dateFrom')?.dateValue || new Date();
    const dateTo = filterElements.find( elt => elt.name === 'dateTo')?.dateValue || new Date();

    const type = filterElements.find( elt => elt.name === 'type')?.value || '';
    
    const arr = await getPayrollProcessings( {type, dateFrom, dateTo} );
    
    return arr;
  }

  const objKey: keyof IPayrollProcessing = 'id';

  return {
    title: t('Payroll processing'), headCells: headPayrollProcessingCells, objKey,
    filterElements, rows: filteredPayrollProcessings, 
    onFilterButtonClick, onRowDoubleClick
  }
}

